import MuiPaper, { PaperProps as MuiPaperProps } from '@material-ui/core/Paper';
import styled from 'styled-components';

import { styledSystem, StyledSystemProps } from '../styledSystem';

export interface PaperProps
  extends Omit<MuiPaperProps, 'color'>,
    StyledSystemProps {
  color?: 'default' | 'paper' | 'element';
}

export const Paper = styled(({ color, ...props }: PaperProps) => (
  <MuiPaper {...props} />
))`
  &&& {
    border-radius: 8px;
    background-color: ${({ theme, color }) =>
      color ? theme.palette.background[color] : theme.palette.background.paper};
    ${styledSystem}
  }
`;
